import React from "react";
import { Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-[#FFD700] flex items-center justify-center">
                <Zap className="w-6 h-6 text-black" strokeWidth={3} />
              </div>
              <div className="font-heading uppercase leading-none">
                <div className="text-xl">VARGAVOLT</div>
                <div className="text-[10px] text-[#FFD700] tracking-[0.4em]">/ KFT.</div>
              </div>
            </div>
            <p className="text-sm text-[#A3A3A3] font-mono">
              Az ország brutálisan jó villanyszerelő csapata. Varga Martin Lajos vezetésével.
              Lakás, ház, ipar — minden, ami villany.
            </p>
          </div>

          <div>
            <div className="font-heading uppercase text-sm text-[#FFD700] mb-4">Szolgáltatások</div>
            <ul className="space-y-2 font-mono text-sm text-[#A3A3A3]">
              <li>Lakossági</li>
              <li>Családi ház</li>
              <li>Ipari</li>
              <li>Okosotthon</li>
              <li>Villámvédelem</li>
              <li>0-24 hibajavítás</li>
            </ul>
          </div>

          <div>
            <div className="font-heading uppercase text-sm text-[#FFD700] mb-4">Területek</div>
            <ul className="space-y-2 font-mono text-sm text-[#A3A3A3]">
              <li>Budapest & Pest megye</li>
              <li>Heves · Nógrád · Jász-N-Sz</li>
              <li>Bács-Kiskun · Fejér</li>
              <li>Tápióbicskétől 200-300 km</li>
              <li>Ipari: országos</li>
            </ul>
          </div>

          <div>
            <div className="font-heading uppercase text-sm text-[#FFD700] mb-4">Cégadatok</div>
            <ul className="space-y-2 font-mono text-sm text-[#A3A3A3]">
              <li>VargaVolt Kft.</li>
              <li>2764 Tápióbicske, Klapka tp. 23.</li>
              <li>Adósz.: 32919725-2-13</li>
              <li>Cégj.: 13-09-243381</li>
              <li>Ügyvezető: Varga Martin Lajos</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#262626] flex flex-col md:flex-row justify-between gap-4">
          <div className="font-mono text-xs text-[#A3A3A3]">
            © {new Date().getFullYear()} VargaVolt Kft. · Minden jog fenntartva.
          </div>
          <div className="font-mono text-xs text-[#A3A3A3]">
            Készült magyar mesterek által. ⚡
          </div>
        </div>
      </div>
    </footer>
  );
}
